module.exports = __webpack_public_path__ + "img/Logo.a7178eac.png";